import { Footer } from 'antd/lib/layout/layout';
import { useState } from 'react';
import { Right } from './styles';

const CustomFooter = () => {

     const [clickedCount,setClickedCount] = useState(0);

    const onClick = () => {

        if (clickedCount <3)
        {
            setClickedCount(clickedCount+1);
        } 
        else
        {
            setClickedCount(0);
            window.open('https://www.linkedin.com/in/raminhabibi', '_blank')?.focus();
        }

    }
    
    return (
        <Footer onClick={() => onClick()}>
            <Right><abbr title="">{"©2006-"} {new Date().getFullYear()} {" Parsipol Khodran. All Rights Reserved."}</abbr></Right>
            {/* <img src='/assets/image/parci-logo.png'  />
            <img src='/assets/image/logo.png'  /> */}
            {/* <img src='/assets/image/banks.png'  /> */}
            {/* <img src='/assets/image/parci-logo.png'  /> */}
        </Footer>
    )
}

export default CustomFooter;